import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Days, getActiveDayIndex, listOfDay} from 'src/app/store/entities';
import {Router} from '@angular/router';
import {NgRedux, Select} from '@angular-redux3/store';
import {ADuplicateSchedule, AFetchSchedule, ASetDay, PlaylistRemoteAppState} from '../../store';
import {Observable, Subscription} from 'rxjs';
import {IScheduleState} from '../../store/reducers/schedule.reducer';
import {getCurrentDay} from '../../utils';
import {ConfigurationForm} from '../../store/entities/configurationForm';
import {DuplicateScheduleForm} from '../../store/entities/duplicateScheduleForm';

// Path: src/app/components/buttons/button/button.component.ts
@Component({
  selector: 'mwo-duplicate-day',
  templateUrl: './duplicate-day.component.html',
  styleUrls: ['./duplicate-day.component.scss'],
})
export class DuplicateDayComponent implements OnInit, OnDestroy {


  private _activeDayIndex: number;
  days = listOfDay;
  activeDay$: Observable<string> = this.ngRedux.select('activeDay');
  activeDay: string;
  @Select(['schedule', 'scheduleUpdateLoading']) scheduleUpdateLoading$: Observable<boolean>;
  schedule$: Observable<IScheduleState> = this.ngRedux.select('schedule');
  schedule: IScheduleState;
  updateLoading: boolean;
  selectedDaysIndexes: Array<number>;
  private subscriptions: Subscription[] = [];

  @Input()
  set activeDayIndex(value: number) {
    this._activeDayIndex = value;
  }
  get activeDayIndex(): number {
    return this._activeDayIndex;
  }

  // output every time the user checks a day a list of days where completed equals true
  @Output() onDayChecked = new EventEmitter<Array<number>>();

  constructor(private router: Router,
              private ngRedux: NgRedux<PlaylistRemoteAppState>) { }

  ngOnInit(): void {
    const scheduleSubscription = this.schedule$.subscribe(value => {
      this.schedule = value;
    });
    this.subscriptions.push(scheduleSubscription)

    const scheduleUpdateLoadingSubscription = this.scheduleUpdateLoading$.subscribe( value => {
      this.updateLoading = value;
    });
    this.subscriptions.push(scheduleUpdateLoadingSubscription);

    const activeDaySubscription = this.activeDay$.subscribe(value => {
      this.activeDay = value;
      this._activeDayIndex = getActiveDayIndex(this.activeDay);
    });
    this.subscriptions.push(activeDaySubscription)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  handleCancel() {
    this.router.navigate(['scheduler-modifier'])
  }

  handleValidate() {
    const configurationForm = new ConfigurationForm(this.selectedDaysIndexes, this.schedule.id)
    const duplicateScheduleForm = new DuplicateScheduleForm(this.schedule[this?.activeDay].id, configurationForm)
    this.ngRedux.dispatch(ADuplicateSchedule(duplicateScheduleForm));
    setTimeout(() => {
      this.ngRedux.dispatch(AFetchSchedule());
    }, 1000);
    setTimeout(() => {
      this.router.navigate(['/scheduler']);
    }, 300);
  }

  handleSelectedDays(list: Array<number>) {
    this.selectedDaysIndexes = list;
  }

  onActiveDayChanged(day: Days = getCurrentDay()) {
    this.ngRedux.dispatch(ASetDay(day));
    this.activeDay = day;
    this._activeDayIndex = getActiveDayIndex(this.activeDay);
    this.selectedDaysIndexes = [this._activeDayIndex];
  }
}
